/**
 * GetFavouritesQuery - Fetches user's favourite pages for header widget
 * Follows MediatR pattern (Query + Handler in same file)
 */

import type { IQuery, IQueryHandler, IHttpClient, BaseApiResponse } from '@/application/core';
import type { FavouritesResponse, FavouriteItem } from './favourites.types';
import { toCamelCase } from '@/utils/caseTransform';

// ============================================================================
// Query (Request)
// ============================================================================

export class GetFavouritesQuery implements IQuery<FavouritesResponse> {
  readonly type = 'GetFavouritesQuery' as const;
}

// ============================================================================
// Handler
// ============================================================================

export class GetFavouritesQueryHandler
  implements IQueryHandler<GetFavouritesQuery, FavouritesResponse>
{
  constructor(private readonly httpClient: IHttpClient) {}

  async handle(_query: GetFavouritesQuery): Promise<FavouritesResponse> {
    const response = await this.httpClient.get<BaseApiResponse<any>>(
      '/api/v1/favourites/top'
    );

    if (!response.succeeded) {
      throw new Error(response.message || 'Failed to fetch favourites');
    }

    const data = response.data;

    // Transform favourite items (handle snake_case -> camelCase)
    const favourites: FavouriteItem[] = (
      data.favourites ??
      data.Favourites ??
      []
    ).map((f: any) => toCamelCase(f));

    return { favourites };
  }
}
